export default __webpack_public_path__ + "static/media/lower_occlusal.38b05274.svg";